// About.js - With image from assets folder
import React from 'react';
import './About.css';
// Import your image from assets folder
import pitacImage from '../../assets/pitac-building.jpeg'; // Adjust path based on your folder structure

const About = () => {
  return (
    <div className="about-page">
      {/* ===== PROFESSIONAL HEADER SECTION ===== */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">
              <i className="fas fa-industry"></i> 
              <span>Federal Ministry of Industries & Production</span>
            </div>
            <h1 className="hero-title">
              <span className="hero-title-light">About</span>
              <span className="hero-title-bold">PITAC</span>
            </h1>
            <p className="hero-subtitle">Pakistan Industrial Technical Assistance Centre</p>
            <div className="hero-divider"></div>
            <p className="hero-description">
              Join Us in Building a Brighter Future — Whether you're a student, professional, 
              or industry leader, PITAC is your partner in achieving excellence.
            </p>
            <div className="hero-stats">
              <div className="hero-stat">
                <span className="hero-stat-number">60+</span>
                <span className="hero-stat-label">Years of Excellence</span>
              </div>
              <div className="hero-stat-divider"></div>
              <div className="hero-stat">
                <span className="hero-stat-number">30K+</span>
                <span className="hero-stat-label">Professionals Trained</span>
              </div>
              <div className="hero-stat-divider"></div>
              <div className="hero-stat">
                <span className="hero-stat-number">100+</span>
                <span className="hero-stat-label">Industry Partners</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== ABOUT PITAC ===== */}
      <section className="about-section">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <span className="section-tag">About PITAC</span>
              <h2>Cornerstone of Pakistan's Industrial Advancement</h2>
              <p>
                The <strong>Pakistan Industrial Technical Assistance Centre (PITAC)</strong>, 
                operating under the Federal Ministry of Industries & Production, is a cornerstone 
                of Pakistan's industrial advancement. We are dedicated to fostering economic growth 
                by equipping individuals and businesses with cutting-edge skills, technical expertise, 
                and innovative solutions.
              </p>
              <p>
                Through our comprehensive training programs and industry-focused services, we empower 
                professionals and organizations to thrive in a competitive global landscape.
              </p>
              
            </div>
            <div className="about-image">
              <div className="image-card">
                {/* Using image from assets folder */}
                <img 
                  src={pitacImage} 
                  alt="PITAC Head Office Lahore" 
                  className="about-img"
                />
                <div className="image-overlay">
                  <span className="image-title">PITAC Head Office</span>
                  <small className="image-location">Lahore, Pakistan</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== MISSION & VISION ===== */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-grid">
            <div className="mission-card">
              <div className="mission-icon">
                <i className="fas fa-bullseye"></i>
              </div>
              <h3>Our Mission</h3>
              <p>
                To upgrade, advise, and extend technical & managerial skill development for sustainable industrial growth and economic value.
              </p>
            </div>
            <div className="mission-card vision">
              <div className="mission-icon">
                <i className="fas fa-eye"></i>
              </div>
              <h3>Our Vision</h3>
              <p>
                TTo attain excellence as the premier organization in technical human resource development and industrial spares manufacturing.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== STATISTICS ===== */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-number">30,000+</span>
              <span className="stat-label">Graduates</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">63%+</span>
              <span className="stat-label">Employability Rate</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">30+</span>
              <span className="stat-label">Industry Partners</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">55+</span>
              <span className="stat-label">Academic Partners</span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHAT WE OFFER ===== */}
      <section className="offer-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Our Services</span>
            <h2>What We Offer</h2>
            <p>Comprehensive solutions for industrial growth and professional development</p>
          </div>
          <div className="offer-grid">
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-chalkboard-teacher"></i>
              </div>
              <h4>Skill Development</h4>
              <p>Industry-relevant training programs to enhance professional expertise.</p>
            </div>
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-drafting-compass"></i>
              </div>
              <h4>Design & Manufacturing Support</h4>
              <p>Custom solutions for jigs, fixtures, molds, and tools.</p>
            </div>
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-headset"></i>
              </div>
              <h4>Advisory Services</h4>
              <p>Expert guidance to overcome industrial and production challenges.</p>
            </div>
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h4>Quality & Productivity Enhancement</h4>
              <p>Strategies to optimize efficiency and reduce operational costs.</p>
            </div>
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-microscope"></i>
              </div>
              <h4>Knowledge Dissemination</h4>
              <p>Specialized workshops, seminars, and training sessions.</p>
            </div>
            <div className="offer-card">
              <div className="offer-icon">
                <i className="fas fa-tools"></i>
              </div>
              <h4>Common Facilities</h4>
              <p>Essential services like casting, heat treatment, and electroplating for SMEs.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== PITAC COLLEGE OF TECHNOLOGY ===== */}
      <section className="pct-section">
        <div className="container">
          <div className="pct-grid">
            <div className="pct-text">
              <span className="section-tag">Education</span>
              <h2>PITAC College of Technology (PCT)</h2>
              <p>
                PCT is a beacon of technical education, offering hands-on learning and research 
                opportunities to cultivate the next generation of industry leaders.
              </p>
              <div className="pct-programs">
                <div className="pct-program">
                  <i className="fas fa-cogs"></i>
                  <div>
                    <h4>Mechanical Technology</h4>
                    <p>Comprehensive training in mechanical systems and manufacturing</p>
                  </div>
                </div>
                <div className="pct-program">
                  <i className="fas fa-bolt"></i>
                  <div>
                    <h4>Electrical Technology</h4>
                    <p>Advanced electrical systems, automation, and power distribution</p>
                  </div>
                </div>
                <div className="pct-program">
                  <i className="fas fa-laptop-code"></i>
                  <div>
                    <h4>Computer Information Technology</h4>
                    <p>Software development, networking, and IT infrastructure</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="pct-image">
              <div className="image-card dark">
                <i className="fas fa-graduation-cap"></i>
                <span>PCT Campus</span>
                <small>State-of-the-art facilities</small>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHY PITAC ===== */}
      <section className="why-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Why Choose Us</span>
            <h2>Why PITAC?</h2>
          </div>
          <div className="why-grid">
            <div className="why-card">
              <span className="why-number">01</span>
              <h4>Leading Training Hub</h4>
              <p>Pakistan's leading Technical and Industrial Training hub with decades of excellence.</p>
            </div>
            <div className="why-card">
              <span className="why-number">02</span>
              <h4>State-of-the-Art Facilities</h4>
              <p>World-class training programs with modern equipment and infrastructure.</p>
            </div>
            <div className="why-card">
              <span className="why-number">03</span>
              <h4>Industry-Aligned Education</h4>
              <p>Industry-aligned diploma courses at PITAC College of Technology.</p>
            </div>
            <div className="why-card">
              <span className="why-number">04</span>
              <h4>Managerial Training</h4>
              <p>Managerial training for corporate excellence and leadership development.</p>
            </div>
            <div className="why-card">
              <span className="why-number">05</span>
              <h4>Tailored Technical Assistance</h4>
              <p>Customized solutions for diverse industries and specific challenges.</p>
            </div>
            <div className="why-card">
              <span className="why-number">06</span>
              <h4>Commitment to Growth</h4>
              <p>Accessible education and sustainable growth for all professionals.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== ACHIEVEMENTS ===== */}
      <section className="achievements-section">
        <div className="container">
          <div className="achievements-grid">
            <div className="achievements-text">
              <span className="section-tag light">Our Impact</span>
              <h2>Making a Difference</h2>
              <p>
                PITAC has continued to train unskilled workmen of SME's and small-scale workshops 
                (cottage) by the provision of Demand Driven Technical Courses resulting in better 
                income and employment opportunities.
              </p>
              <p>
                In this way, PITAC has directly contributed towards Skill development for the SME's 
                and light engineering sector in accordance with the National Industrial Policy 2012 
                devised by Ministry of Industries, Government of Pakistan.
              </p>
              <div className="highlight-box">
                <i className="fas fa-quote-left"></i>
                <p>
                  It is hoped that the workmen acquainted with Technical Skills will be a strong 
                  backbone for the industry of this country in the future.
                </p>
              </div>
            </div>
            <div className="achievements-stats">
              <div className="achievement-stat">
                <span className="number">50,000+</span>
                <span className="label">Workmen Trained</span>
              </div>
              <div className="achievement-stat">
                <span className="number">500+</span>
                <span className="label">SMEs Supported</span>
              </div>
              <div className="achievement-stat">
                <span className="number">1,000+</span>
                <span className="label">Projects Completed</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHAT WE DO ===== */}
      <section className="technical-section">
        <div className="container">
          <div className="technical-grid">
            <div className="technical-text">
              <span className="section-tag">Technical Assistance</span>
              <h2>What We Do</h2>
              <ul className="technical-list">
                <li>
                  <i className="fas fa-user-graduate"></i>
                  <span>Train and upgrade skills of Industrial and Management personnel associated with Industrial sector of Pakistan</span>
                </li>
                <li>
                  <i className="fas fa-tools"></i>
                  <span>Design and Manufacture production Tooling i.e. Jigs, Fixture, Gauges, Injection Models, Compression Models, Blow Models, Dies and Tools of various industries</span>
                </li>
                <li>
                  <i className="fas fa-chalkboard"></i>
                  <span>Disseminate modern technical knowhow among industrial personnel through demand driven intensive training programs, seminars, workshops, group discussions and demonstrations</span>
                </li>
                <li>
                  <i className="fas fa-handshake"></i>
                  <span>Extend advisory services to industries, both public and private sector, to solve their in-plant production problems</span>
                </li>
                <li>
                  <i className="fas fa-industry"></i>
                  <span>Provide exquisite common facilities in Metal working, Casting, Heat Treatment, Electroplating, Surface Treatment, Designing and Manufacturing of machine elements and reverse engineering to the Light Engineering Sector</span>
                </li>
                <li>
                  <i className="fas fa-chart-bar"></i>
                  <span>Help industries in improving quality of their products, increasing production, decreasing cost and extending scope of indigenous manufacturing</span>
                </li>
              </ul>
            </div>
            <div className="technical-image">
              <div className="image-card">
                <i className="fas fa-microchip"></i>
                <span>Technical Excellence</span>
                <small>Innovation & Quality</small>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHAT WE PROVIDE ===== */}
      <section className="provide-section">
        <div className="container">
          <div className="provide-content">
            <span className="section-tag">Our Commitment</span>
            <h2>What We Provide</h2>
            <div className="provide-quote">
              <i className="fas fa-quote-left"></i>
              <p>
                PITAC today is providing a service to Pakistan which can only be measured in the 
                number of Engineers/Students and Projects that go through our hands, who then go 
                and provide a service to Pakistan in their respective fields, a figure which cannot 
                be quantified in figures but by the quality of training and service we provide.
              </p>
              <i className="fas fa-quote-right"></i>
            </div>
          </div>
        </div>
      </section>

      {/* ===== DEPARTMENTS ===== */}
      <section className="departments-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Our Structure</span>
            <h2>Departments</h2>
            <p>Pakistan Industrial Technical Assistance Center has various departments to help the people.</p>
          </div>
          <div className="departments-grid">
            <div className="department-card">
              <i className="fas fa-users-cog"></i>
              <h4>Operation & Works</h4>
              <p className="dept-title">Director (Operation & Works)</p>
              <p className="dept-address">234-Ferozepur Road Lahore</p>
              <p className="dept-contact"><i className="fas fa-phone"></i> (042) 99230576</p>
              <p className="dept-contact"><i className="fas fa-envelope"></i> smo@pitac.gov.pk</p>
            </div>
            <div className="department-card">
              <i className="fas fa-bullhorn"></i>
              <h4>Marketing Department</h4>
              <p className="dept-title">Director (Marketing)</p>
              <p className="dept-address">234-Ferozepur Road Lahore</p>
              <p className="dept-contact"><i className="fas fa-phone"></i> (042) 99230245</p>
              <p className="dept-contact"><i className="fas fa-envelope"></i> info@pitac.gov.pk</p>
            </div>
            <div className="department-card">
              <i className="fas fa-lightbulb"></i>
              <h4>IED Department</h4>
              <p className="dept-title">Deputy Director (IED)</p>
              <p className="dept-address">234-Ferozepur Road Lahore</p>
              <p className="dept-contact"><i className="fas fa-phone"></i> (042) 99230538</p>
              <p className="dept-contact"><i className="fas fa-envelope"></i> ied@pitac.gov.pk</p>
            </div>
            <div className="department-card">
              <i className="fas fa-user-tie"></i>
              <h4>Administration Department</h4>
              <p className="dept-title">Deputy Director (P & A)</p>
              <p className="dept-address">234-Ferozepur Road Lahore</p>
              <p className="dept-contact"><i className="fas fa-phone"></i> (042) 99231506</p>
              <p className="dept-contact"><i className="fas fa-envelope"></i> admin@pitac.gov.pk</p>
            </div>
            <div className="department-card">
              <i className="fas fa-database"></i>
              <h4>MIS Department</h4>
              <p className="dept-title">Deputy Director (MIS)</p>
              <p className="dept-address">234-Ferozepur Road Lahore</p>
              <p className="dept-contact"><i className="fas fa-phone"></i> (042) 99230245</p>
              <p className="dept-contact"><i className="fas fa-envelope"></i> info@pitac.gov.pk</p>
            </div>
            <div className="department-card">
              <i className="fas fa-chalkboard-teacher"></i>
              <h4>Training Department</h4>
              <p className="dept-title">I/C Training</p>
              <p className="dept-address">234-Ferozepur Road Lahore</p>
              <p className="dept-contact"><i className="fas fa-phone"></i> (042) 99230701</p>
              <p className="dept-contact"><i className="fas fa-envelope"></i> Training@pitac.gov.pk</p>
            </div>
            <div className="department-card">
              <i className="fas fa-cogs"></i>
              <h4>Machine Tool Shop</h4>
              <p className="dept-title">Deputy Director (Machine Shop)</p>
              <p className="dept-address">234-Ferozepur Road Lahore</p>
              <p className="dept-contact"><i className="fas fa-phone"></i> (042) 99230525</p>
              <p className="dept-contact"><i className="fas fa-envelope"></i> info@pitac.gov.pk</p>
            </div>
            <div className="department-card">
              <i className="fas fa-industry"></i>
              <h4>Plastic Mold Department</h4>
              <p className="dept-title">Deputy Director (PMD)</p>
              <p className="dept-address">234-Ferozepur Road Lahore</p>
              <p className="dept-contact"><i className="fas fa-phone"></i> (042) 99230315</p>
              <p className="dept-contact"><i className="fas fa-envelope"></i> pmd@pitac.gov.pk</p>
            </div>
            <div className="department-card">
              <i className="fas fa-handshake"></i>
              <h4>Coordination Department</h4>
              <p className="dept-title">Deputy Director (Coordination)</p>
              <p className="dept-address">234-Ferozepur Road Lahore</p>
              <p className="dept-contact"><i className="fas fa-phone"></i> (042) 99230601</p>
              <p className="dept-contact"><i className="fas fa-envelope"></i> Coordination@pitac.gov.pk</p>
            </div>
            <div className="department-card">
              <i className="fas fa-calculator"></i>
              <h4>Accounts Department</h4>
              <p className="dept-title">Deputy Director (Accounts)</p>
              <p className="dept-address">234-Ferozepur Road Lahore</p>
              <p className="dept-contact"><i className="fas fa-phone"></i> (042) 99230563</p>
              <p className="dept-contact"><i className="fas fa-envelope"></i> accounts@pitac.gov.pk</p>
            </div>
            <div className="department-card">
              <i className="fas fa-drafting-compass"></i>
              <h4>Engineering Design Department</h4>
              <p className="dept-title">Deputy Director (EDD)</p>
              <p className="dept-address">234-Ferozepur Road Lahore</p>
              <p className="dept-contact"><i className="fas fa-phone"></i> (042) 99230563</p>
              <p className="dept-contact"><i className="fas fa-envelope"></i> edd@pitac.gov.pk</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;